import React from 'react';

export default function CmSkeleton({ rows = 10, cols }) {
  const colCount = cols && cols > 0 ? cols : 6;
  return (
    <>
      {Array.from({ length: rows }).map((_, ri) => (
        <tr key={ri} className="cm-skeleton-row">
          <td className="cm-dt-actions">
            <div className="cm-skeleton-bar" style={{ width: 20, height: 14 }} />
          </td>
          <td className="cm-dt-check">
            <div className="cm-skeleton-bar" style={{ width: 16, height: 16 }} />
          </td>
          {Array.from({ length: colCount }).map((_, ci) => (
            <td key={ci}>
              <div
                className="cm-skeleton-bar"
                style={{ width: `${70 + Math.random() * 25}%`, height: 14 }}
              />
            </td>
          ))}
        </tr>
      ))}
    </>
  );
}
